export const featuresTypes = [
  'channels',
  'dataTypes',
  'productTypes',
  'purposeTypes',
] as const;
